function setSortBy(sortValue) {
  if (sortValue) {
    const cleanValue = sortValue.replace('sortby=', '');
    this.$data.settings.filters.sortby = `sortby=${cleanValue}`;
    this.$data.settings.currentSortby = cleanValue;
  } else {
    this.$data.settings.filters.sortby = '';
    this.$data.settings.currentSortby = '';
  }
}

export default setSortBy;
